import { USER_ROLES } from './index';
import { PORTAL_ACCENT } from '../styles/portalTheme';

/** Backend `data.type` values for portal community notifications. */
export const COMMUNITY_NOTIFICATION_TYPE = {
  PARTNER_GROUP_JOIN_REQUEST: 'partner_group_join_request',
  PARTNER_GROUP_CHAT_MESSAGE: 'partner_group_chat_message',
  PARTNER_GROUP_MEMBER_AUTO_JOINED: 'partner_group_member_auto_joined',
  PARTNER_GROUP_MEMBER_JOINED: 'partner_group_member_joined',
};

export const PARTNER_GROUP_JOIN_REQUEST_TARGET_TYPE = 'partner_group_join_request';
export const PARTNER_GROUP_CHAT_MESSAGE_TARGET_TYPE = 'partner_group_chat_message';
export const PARTNER_GROUP_MEMBER_AUTO_JOINED_TARGET_TYPE = 'partner_group_member_auto_joined';
export const PARTNER_GROUP_MEMBER_JOINED_TARGET_TYPE = 'partner_group_member_joined';

export const PARTNER_COMMUNITY_MEMBER_NOTIFICATION_TARGET_TYPES = [
  PARTNER_GROUP_MEMBER_AUTO_JOINED_TARGET_TYPE,
  PARTNER_GROUP_MEMBER_JOINED_TARGET_TYPE,
];

export const PARTNER_COMMUNITY_JOIN_REQUESTS_TAB = 'join-requests';
export const PARTNER_COMMUNITY_PATH = '/partner-community';

export const PARTNER_COMMUNITY_JOIN_REQUESTS_PATH = `${PARTNER_COMMUNITY_PATH}?tab=${PARTNER_COMMUNITY_JOIN_REQUESTS_TAB}`;

export const COMMUNITY_NOTIFICATION_CATALOG = {
  [COMMUNITY_NOTIFICATION_TYPE.PARTNER_GROUP_JOIN_REQUEST]: {
    recipientRole: USER_ROLES.PARTNER,
    actorRole: null,
    label: 'Community join request',
    accentColor: PORTAL_ACCENT,
  },
  [COMMUNITY_NOTIFICATION_TYPE.PARTNER_GROUP_CHAT_MESSAGE]: {
    recipientRole: USER_ROLES.PARTNER,
    actorRole: null,
    label: 'Community message',
    accentColor: PORTAL_ACCENT,
  },
  [COMMUNITY_NOTIFICATION_TYPE.PARTNER_GROUP_MEMBER_AUTO_JOINED]: {
    recipientRole: USER_ROLES.PARTNER,
    actorRole: null,
    label: 'Member joined via event',
    accentColor: PORTAL_ACCENT,
  },
  [COMMUNITY_NOTIFICATION_TYPE.PARTNER_GROUP_MEMBER_JOINED]: {
    recipientRole: USER_ROLES.PARTNER,
    actorRole: null,
    label: 'New community member',
    accentColor: PORTAL_ACCENT,
  },
};

const normalizeTypeKey = (type) =>
  String(type || '')
    .trim()
    .toLowerCase();

export const getCommunityNotificationMeta = (type) => {
  const key = normalizeTypeKey(type);
  return COMMUNITY_NOTIFICATION_CATALOG[key] ?? null;
};

export const isCommunityNotificationForRole = (type, userRole) => {
  const meta = getCommunityNotificationMeta(type);
  return meta?.recipientRole === userRole;
};

export const resolveCommunityNotificationPath = ({ type, viewerRole }) => {
  const isPartner = viewerRole === USER_ROLES.PARTNER;
  const normalizedType = normalizeTypeKey(type);

  switch (normalizedType) {
    case COMMUNITY_NOTIFICATION_TYPE.PARTNER_GROUP_JOIN_REQUEST:
      return isPartner ? PARTNER_COMMUNITY_JOIN_REQUESTS_PATH : '/notifications';
    case COMMUNITY_NOTIFICATION_TYPE.PARTNER_GROUP_CHAT_MESSAGE:
      return isPartner ? PARTNER_COMMUNITY_PATH : '/notifications';
    case COMMUNITY_NOTIFICATION_TYPE.PARTNER_GROUP_MEMBER_AUTO_JOINED:
    case COMMUNITY_NOTIFICATION_TYPE.PARTNER_GROUP_MEMBER_JOINED:
      return isPartner ? PARTNER_COMMUNITY_PATH : '/notifications';
    default:
      return isPartner ? PARTNER_COMMUNITY_PATH : '/notifications';
  }
};
